import { render, staticRenderFns } from "./uploadPics.vue?vue&type=template&id=0581a89c&scoped=true&"
import script from "./uploadPics.vue?vue&type=script&lang=js&"
export * from "./uploadPics.vue?vue&type=script&lang=js&"
import style0 from "./uploadPics.vue?vue&type=style&index=0&id=0581a89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0581a89c",
  null
  
)

export default component.exports